import { cardRef, defineGameCard, onResolve } from '../authoring/index.js';
import { createFragmentAtCell, plannedCell } from './helpers.js';
export const SparePartCard = defineGameCard({
    id: 'spare_part',
    gameplay: {
        type: 'SPELL', cost: 1,
        planning: {
            target: 'cell',
            validatePlan(state, playerId, plan) {
                const cell = plan.targetCellId === undefined ? undefined : state.board.cells[plan.targetCellId];
                return cell !== undefined && cell.side === state.players[playerId]?.side && cell.occupantId === null;
            },
        },
    },
    presentation: {
        name: 'Запасная деталь',
        description: 'Создайте Фрагмент в выбранной свободной ячейке. Если это второй Фрагмент в локации, они сразу собираются в робота.',
        glyph: {
            colors: ['#10213A', '#778796', '#4A5462', '#2F313A', '#9D503A'],
            rows: [
                '....................',
                '.......11111........',
                '......1222221.......',
                '.....122222231......',
                '.....122222231......',
                '.....122211231......',
                '.....121244131......',
                '.....131221131......',
                '.....133133331......',
                '.....133311341......',
                '......1333331.......',
                '.......11111........',
                '.......132231.......',
                '.......132231.......',
                '.......155551.......',
                '.......155551.......',
                '........1331........',
                '........1231........',
                '.........11.........',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('fragment'), cardRef('reconstructed_robot')],
    abilities: [
        onResolve((ctx) => {
            const targetCellId = plannedCell(ctx);
            if (targetCellId !== undefined)
                createFragmentAtCell(ctx, ctx.self.controllerId, targetCellId);
        }),
    ],
    ui: { mechanics: ['fragment', 'assembly'] },
});
//# sourceMappingURL=spare-part.js.map